import { styled } from "styled-components";

import Button from "components/Button";
import CallToAction from "components/CallToAction";
import {
    Link as CallToActionLink,
    Heading as CallToActionHeading,
    Text,
} from "components/CallToAction/CallToAction.styled";
import Profile from "components/Profile";
import SearchField from "components/SearchField";
import { Container as GridContainer } from "style/components/Page";
import { styleBodyL } from "style/components/Typography";
import { columnGap } from "style/grid";
import { MQ } from "style/mediaQueries";

export const Container = styled(GridContainer)`
    ${columnGap};
    display: grid;
    grid-template-columns: repeat(4, [col-start] 1fr);
    padding-bottom: 4.375rem;
    padding-top: 0;

    ${MQ.FROM_M} {
        grid-template-columns: repeat(12, [col-start] 1fr);
        padding-bottom: 6.125rem;
    }

    ${MQ.FROM_XL} {
        padding-bottom: 8.75rem;
    }
`;

export const SearchForm = styled(SearchField)`
    && {
        margin-bottom: 2.625rem;
        padding-bottom: 0;
        row-gap: 0;

        ${MQ.FROM_M} {
            margin-bottom: 3.5rem;
        }

        ${MQ.FROM_XL} {
            margin-bottom: 5.25rem;
        }
    }
`;

export const SearchResults = styled.div`
    display: flex;
    flex-flow: column wrap;
    grid-column: col-start 1 / span 4;
    row-gap: 1.75rem;

    ${MQ.FROM_M} {
        grid-column: col-start 5 / span 8;
        row-gap: 2.625rem;
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 6 / span 6;
        row-gap: 3.5rem;
    }
`;

export const SearchProfile = styled(Profile)`
    border-top: 1px solid var(--line-on-neutral-default);
    padding-top: 1.75rem;

    ${MQ.FROM_M} {
        padding-top: 2.625rem;
    }

    ${MQ.FROM_XL} {
        padding-top: 3.5rem;
    }
`;

export const SearchResult = styled(CallToAction)`
    && {
        ${CallToActionHeading} {
            em {
                font-style: normal;
            }
        }

        ${CallToActionLink} {
            padding-top: 1.75rem;

            ${MQ.FROM_M} {
                padding-top: 2.625rem;
            }

            ${MQ.FROM_XL} {
                padding-top: 3.5rem;
            }
        }

        ${Text} {
            margin-bottom: 0;
        }
    }
`;

export const SearchFilters = styled.div`
    align-items: flex-start;
    align-self: flex-start;
    display: flex;
    flex-flow: row wrap;
    gap: 0.4375rem 0.875rem;
    grid-column: col-start 1 / span 4;
    margin: 0;
    margin-bottom: 1.75rem;
    width: 100%;

    ${MQ.FROM_M} {
        flex-flow: column;
        grid-column: col-start 1 / span 4;
        margin-bottom: 0;
        row-gap: 0.875rem;
    }

    ${MQ.FROM_L} {
        flex-flow: row wrap;
        grid-column: col-start 1 / span 3;
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 1 / span 4;
    }
`;

export const NoResults = styled.div`
    ${styleBodyL};
    color: var(--text-on-neutral-secondary);
    font-style: italic;
`;

export const LoadMore = styled(Button)`
    grid-column: col-start 1 / span 4;
    justify-self: flex-start;
    margin-top: 4.375rem;

    ${MQ.FROM_M} {
        grid-column: col-start 5 / span 8;
        margin-top: 6.125rem;
    }

    ${MQ.FROM_XL} {
        grid-column: col-start 6 / span 6;
        margin-top: 8.75rem;
    }
`;
